var exports = {
  "k": "x9997bc76--80c165--container",
};

module.exports = exports;
